import { useRef, useEffect } from 'react';
import confetti from 'canvas-confetti';

function Confetti({
  triggerKey = null,
  otherClassNames = '',
  style = {},
  spread = 360,
  startVelocity = 45,
  particleCount = 50,
}) {
  const canvasRef = useRef(null);
  const anchorRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const anchor = anchorRef.current;
    if (!canvas || !anchor) return;

    const myConfetti = confetti.create(canvas, { resize: true, useWorker: false });
    const { x, y, width, height } = anchor?.getBoundingClientRect() ?? {};

    myConfetti({
      origin: {
        x: (x + width / 2) / window.innerWidth,
        y: (y + height / 2) / window.innerHeight,
      },
      colors: ['#19b135', '#335168', '#d6b73d', '#d51c26'],
      spread,
      startVelocity,
      particleCount,
      ticks: 100,
      disableForReducedMotion: true,
    });

    return () => {
      const ctx = canvas.getContext('2d');
      if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
  }, [triggerKey, spread, startVelocity, particleCount]);

  return (
    <>
      <span role="alert" aria-label="Hooray!" ref={anchorRef} className={otherClassNames} />
      <canvas
        ref={canvasRef}
        style={{
          position: 'fixed',
          pointerEvents: 'none',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 16777271,
          ...style,
        }}
      />
    </>
  );
}

export default Confetti;
